<div
  class="lock icon is-primary has-background-primary-light"
  [class.lock--inline]="inline"
  [class.lock--corner]="corner"
>
  <i class="fa fa-lock has-text-primary" style="font-size: 0.75rem"></i>
</div>
